import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import subscription from './subscription/subscription.js'

export default contract({
  subscription: array([
    subscription
  ])
})